import EmployeeSalaryLateEarltDeductComponents from "../components/EmployeeSalaryLateEarltDeduct";
import useEmployeeSalaryLateEarltDeduct from "../hooks/useEmployeeSalaryLateEarltDeduct";

function EmployeeSalaryLateEarltDeduct() {
  const employeeSalaryLateEarltDeductProps = useEmployeeSalaryLateEarltDeduct();
  return (
    <EmployeeSalaryLateEarltDeductComponents
      {...employeeSalaryLateEarltDeductProps}
    />
  );
}

export default EmployeeSalaryLateEarltDeduct;
